<div [ngStyle]="{ width: progress + '%' }" class="progress-bar"></div>
